import { LocationDTO } from "src/app/features/locations-map/models/LocationDTO";

export function CreateEmptyLocationDTO() : LocationDTO {
    return {
        id: 0,
        guid: '',
        cordsX: '',
        cordsY: '',
        identifier: '',
        description: '',
        color: '',
        data: [],
        counts: 0,
        icon: '',
        panelIcon: '',
        locationCategory: '',
        idLocationCategory: 0,
        group: {
          id: 0,
          name: '',
        },
        subGroup: {
          id: 0,
          name: '',
        },
        alias: '',
        isFullyAvailable: false,
        lastVoltaje: '',
        gpsStatus: '',
        canLock: '',
        lastUpdate: '',
        batteryPercent: '',
        activeType: '',
        statusVehiculo: '',
        categoryStatus: '',
        statusFlags: [],
        flagTypes: [],
      };
}